import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/**
 * 引用ElementUI 通用样式 和 默认样式
 */
import ElementUI from 'element-ui'
import '@/assets/style/common.scss'
import '@/assets/style/iconfont.css'
import 'normalize.css'
import animated from 'animate.css';

/**
 * 引入第三方方法
 */
import Cookies from 'js-cookie'
import Storage from 'store'
import * as Methods from '@/utils/Methods'
import Moment from 'moment'
import 'moment/locale/zh-cn'
import VueClipboard from 'vue-clipboard2'
import contentmenu from 'v-contextmenu'
import 'v-contextmenu/dist/index.css'

/**
 * api 和 自定义方法
 */
import Api from '@/utils/Api.js'

Vue.prototype.$api = Api;
Vue.prototype.$methods = Methods;

/**
 * 引入localStorage、cookie和moment时间插件
 */
Vue.prototype.$localStorage = Storage;
Vue.prototype.$cookies = Cookies;
Vue.prototype.$moment = Moment;

Vue.use(ElementUI);
Vue.use(animated)
Vue.use(animated);
Vue.use(VueClipboard);
Vue.use(contentmenu);
ElementUI.Dialog.props.closeOnClickModal.default = false
ElementUI.Dialog.props.appendToBody.default = true
ElementUI.Drawer.props.appendToBody.default = true
ElementUI.Drawer.props.destroyOnClose.default = true
ElementUI.Drawer.props.wrapperClosable.default = false
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
